<template>
    <div id="archivo_div" class="w-100 px-0 py-0">
        <div id="TituloDetalleDeDocumento_div">
            <h6>LISTA PARA ENVIO SALA DE LECTURA</h6>
        </div>
        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
                <div class="area">
                    <div class="form-group" id="Anio_div">
                        <label>Fecha de Lista de Acuerdos</label>
                        <input class="form-control" type="date" v-model="FechaEnvio"/>
                    </div>
                    <div id="VerificarFecha_div" class="text-right">
                        <button class="btn btn-sm btn-dark"  @click='VerificarFecha()'>Verificar Fecha de Listado</button>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;" v-if="EnviarSecretos ==false">
                <div class="area">
                    <div id="Tabla_Lectura">
                        <div class="form-group col-12" >
                            <h5>{{this.TiuloSobreTabla}}</h5>
                        </div>
                        
                        <div v-if="EnvioSala!=true" class="table-responsive">
                            <table class="table table-striped table-light table-hover table-sm table-bordered">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Consecutivo</th>
                                        <th>Contenido</th>
                                        <!-- <th>Observaciones</th> -->
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark">
                                    <tr v-if="ListaFinal.length <= 0">
                                        <td colspan="4" class="text-center">Sin Documentos para Envío a Sala de Lectura</td>
                                    </tr>
                                    <tr v-else v-for="Lista in ListaFinal" :key ="Lista.InventarioDocumentoId">
                                        <td width ="200" v-html="TipoDocumentoHTML(Lista.TipoDocumentoId)" ></td>
                                        
                                        <td width= "100" v-html="VerificaElementoFueraParaTabla(Lista)"></td>
                                        <td width ="450" v-html="DesglosaContenido(Lista)"></td>
                                        <!-- <td witdh ="200" v-html="VerificaUbicacion(Lista)"></td> -->
                                        <td width="30" class="category_enabled text-center">
                                            <input type="checkbox" v-model="SelEnviar" v-bind:value="Lista.InventarioDocumentoId" @click="checkDocumento($event)"/>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-else class="table-responsive">
                            <table class="table table-striped table-light table-hover table-sm table-bordered">
                                <thead class="thead-dark">
                                    <tr>
                                        <th class="text-center"> 
                                            Todos : 
                                            <input id="checkTotodos" type="checkbox" v-on:click="SelectAll($event)" v-model="SeleccionarTodos" class="vertical-align-bottom" />
                                        </th>
                                        <th>Tipo</th>
                                        <th>Consecutivo</th>
                                        <th>Contenido</th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark">
                                    <tr v-if="ListaFinal.length <= 0">
                                        <td colspan="12" class="text-center">Sin Documentos para Envío a Sala de Lectura</td>
                                    </tr>
                                    <tr v-else v-for="Lista in ListaFinal" :key ="Lista.InventarioDocumentoId">
                                        <td class="category_enabled text-center" >
                                            <input v-model="Parcial" v-bind:value="Lista.InventarioDocumentoId" type="checkbox" />
                                        </td>
                                        <td width ="200" v-html="TipoDocumentoHTML(Lista.TipoDocumentoId)" ></td>
                                        <td width= "100">{{Lista.Consecutivo}}</td>
                                        <td width ="800" v-html="DesglosaContenido(Lista)"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="row" v-if="ListaFinal.length>0">
                            
                            <div class="form-group text-right col-12" v-if="EnvioSala==false && EnableEnvio== true">
                                <button class="btn btn-sm btn-dark" @click='GenerarMovimientos(ListaFinal)'>Enviar Listado a Sala de Lectura</button>
                            </div>
                            <div class="form-group text-right col-12" v-if="EnvioSala==true">
                                <button class="btn btn-sm btn-dark" @click='GenerarRecepcion(ListaFinal)'>Recibir Documentos de Sala de Lectura</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;" v-if="EnviarSecretos ==true">
                <div class="area">
                    <div class="form-group col-12" v-if="ListaSecretos.length>0">
                        <h6>Documentos con Acuerdo Secreto : {{ListaSecretos.length}}</h6>
                    </div>
                    <div id="Table_Secretos">
                        <div v-if="EnviarSecretos==true" class="table-responsive">
                            <table class="table table-striped table-light table-hover table-sm table-bordered">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Consecutivo</th>
                                        <th>Contenido</th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark">
                                    <tr v-if="ListaSecretos.length <= 0">
                                        <td colspan="4" class="text-center">Sin Documentos para asignacióm</td>
                                    </tr>
                                        <tr v-else v-for="Lista in ListaSecretos" :key ="Lista.InventarioDocumentoId">
                                        <td width ="200" v-html="TipoDocumentoHTML(Lista.TipoDocumentoId)" ></td>
                                        <td width= "100" >{{Lista.Consecutivo}}</td>
                                        <td width ="450" v-html="DesglosaContenido(Lista)"></td>
                                    </tr>
                                    </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="form-group text-right col-12" v-if="EnvioSala==false && EnableEnvio== true">
                                <button class="btn btn-sm btn-success" @click='MoverSecretos(ListaSecretos)'>&nbsp;&nbsp;&nbsp;&nbsp;ASIGNAR&nbsp;&nbsp;&nbsp;&nbsp;</button>
                            </div>
                        </div>
                    </div>
                </div>
             </div>
            <div v-if="Edicion==true">
                <modal :DocumentoPadre=this.DocumentoEdicion @dialogo='EstatusModal($event)'></modal>
            </div>
        </div>
    </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import LogoPJE from '@/../src/assets/logo-pj-transparente-negro.png'
import ModalEdicion from '@/components/ArchivoJudicial/Movimientos/modalModicacionSalaLectura.vue'

export default {
    data(){
        return{
            FechaEnvio: "",
            AreaQueConsulta: {},
            ListaDeDocumentosAcuerdo: [],
            movimientosReubiacion: [],
            movimientoSoloRecepcion : [],
            ListaRecepcion: [],
            ListaParaVerificar: [],
            ListaSecretos: [],
            ListaFinal: [],
            TiuloSobreTabla: "",
            TiuloSobreVales:"",
            filtro : null,
            Edicion: false,
            DocumentoEdicion: {},
            EnvioSala : false,
            EnableEnvio: true,
            FueraArea: 0,
            ListaVales: [],
            Parcial: [], 
            SelEnviar: [],
            SeleccionarTodos: true,
            EnviarSecretos : false
        }
    },
    props: {
    ListaPrevia: []
    },
    components: {
        modal: ModalEdicion
    },
    methods:{
        VerificarFecha(){
            this.ListaDeDocumentosAcuerdo = [];
            this.ListaRecepcion = [];
            this.ListaSecretos = [];
            this.ListaParaVerificar=[];
            this.ListaFinal= [];
            this.ListaVales= [];
            this.SelEnviar =[];
            this.EnviarSecretos = false;
            var AreaId = this.AreaQueConsulta.Area.AreaId;
            if(this.FechaEnvio!= null && this.FechaEnvio!="")
            {
                comun.SeEstaCargandoInformacion(true);
                $('#navTabla_Lectura').remove();
                $('#navTable_Secretos').remove();
                var peticion = {"AreaId": AreaId, "FechaEnvio": this.FechaEnvio};
                axios.post(api.conexion + api.ArchivoJudicial.FechaListadoAcuerdo, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then( respuesta => {
                if(respuesta.data.SiHayError)
                    {
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    }

                else
                    {   
                        
                        this.ListaRecepcion = respuesta.data.DocumentosParaRecepcion;
                        var tomos = respuesta.data.ParaEnviarPorAcuerdoTomos;
                        var incidentes = respuesta.data.ParaEnviarPorAcuerdoIncidentes;
                        var tercerias = respuesta.data.ParaEnviarPorAcuerdoTercerias;
                        var sec1 = respuesta.data.ParaEnviarSecretosTomos;
                        var sec2 = respuesta.data.ParaEnviarSecretosIncidentes;
                        var sec3 = respuesta.data.ParaEnviarSecretosTercerias;
                        if(this.ListaRecepcion.length<=0)
                        {
                            
                            var Tabla = this.OrganizaVolumenes(tomos, incidentes, tercerias);
                            this.ListaFinal = Tabla;
                            this.ListaFinal.sort((a,b)=>(a.CodigoBarras>b.CodigoBarras ? 1:-1));
                            this.SelectTodosEnvios();
                            this.TiuloSobreTabla = "Lista de Acuerdos del "+ moment(this.FechaEnvio).format('DD/MM/YYYY') + ", Total de Documentos para Envío :  " + this.SelEnviar.length
                            this.EnvioSala = false;
                            
                            this.$nextTick(()=> { PaginarTabla('Tabla_Lectura', 20)});
                            if(sec1.length>0)
                            {
                                this.ListaSecretos = this.OrganizaVolumenes(sec1,sec2,sec3);
                                this.ListaSecretos.sort((a,b)=>(a.CodigoBarras>b.CodigoBarras ? 1:-1));
                            }
                            comun.SeEstaCargandoInformacion(false);
                            //this.VerificaUbicacion(this.ListaFinal);
                            
                        }
                        else{
                            this.ListaFinal= this.OrganizaParaRecepcion(this.ListaRecepcion);
                            this.ListaFinal.sort((a,b)=>(a.CodigoBarras>b.CodigoBarras ? 1:-1));
                            
                            this.EnvioSala = true;
                            this.TiuloSobreTabla = "Lista de Acuerdos del "+ moment(this.FechaEnvio).format('DD/MM/YYYY') + ", Total de Documentos para Recepción :  " + this.ListaFinal.length
                            
                            this.$nextTick(()=> { PaginarTabla('Tabla_Lectura', 20)});
                            
                            comun.SeEstaCargandoInformacion(false);
                        }
                        
                    }
                })
                .catch(excepcion => {
                        console.log(excepcion);
                        console.log("fallo por parametros");
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);
                });
            }
            else
            {
                comun.mensajeDeAlerta("Defina Fecha Valida para Verificar Listado", null, null);
            }
        },
        GenerarMovimientos: function(datos){
            //Generamos un Movimientos de ida y vuelta a Sala de Lectura
            let MovimientosDocumentos =[];
            let UsuarioRecibe = this.AreaQueConsulta.UsuarioId;
            var Area= this.AreaQueConsulta.Area.AreaId;
            var AreaOrigen = this.AreaQueConsulta.Area;
            this.TiuloSobreTabla = "";
            let fechaTexto = moment(this.FechaEnvio).format('DD/MM/YYYY');
            let Secretos = [];
            
            let aEnviar= this.ObtenerSeleccionados(datos);
            var fechaListaAcuerdo = this.FechaEnvio;
            $.each(aEnviar, function(index, listado)
            {
                if((listado.AreaQuePresta==0 && listado.AreaQueRecibe== Area && listado.FechaRecepcion==null && listado.AreaExternaId!=null) || (listado.AreaQueRecibe!= Area))
                {
                    console.log("No enviar")
                }
                else
                {
                    MovimientosDocumentos.push({
                        "VolumenId": listado.VolumenId!=null ? listado.VolumenId: null ,
                        "IncidenteId": listado.IncidenteId!=null ? listado.IncidenteId: null,
                        "TerceriaId": listado.TerceriaId!=null ?listado.TerceriaId: null,
                        "FechaMovimiento": null,
                        "UsuarioQuienPresta" :{"IdUsuario":null},
                        "UsuarioQuienRecibe" :{"IdUsuario": null},
                        "AreaQuePresta": {"AreaId": Area},
                        "AreaQueRecibe": {"AreaId": 35},
                        "AreaExterna": null,
                        "SolicitudDocumentoId" : null,
                        "FechaRecepcion": null,
                        "ListaAcuerdo": fechaListaAcuerdo,
                        "Observaciones" : "Documento Enviado a Sala de Lectura Fecha : " + fechaTexto}
                    );
                }
            });
            
            let Reubicacion = this.movimientosReubiacion;
            var peticion = {MovimientosDocumentos, Reubicacion, Secretos, "AreaId": Area};
            
            
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.EnvioSalaLectura, peticion, comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
            if(respuesta.data.SiHayError)
            {
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            }
            else
            {  
                let _this = this;
                $('#navTabla_Lectura').remove();
                comun.SeEstaCargandoInformacion(false);
                if(this.ListaSecretos.length>0)
                {
                    bootbox.confirm({
                    title: "Mensaje del sistema",
                    message: "Desea asignarse los documentos con acuerdo secreto?",
                    buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;CANCELAR'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;ACEPTAR'
                    }
                    },
                    callback: (respuestaConfirmar) => {
                            if (respuestaConfirmar) 
                            {
                                $('#navTable_Secretos').remove();
                                this.EnviarSecretos = true;
                                this.$nextTick(()=> { PaginarTabla('Table_Secretos', 20)});
                            }
                        }
                    });
                }
                this.ListaDeDocumentosAcuerdo=[];
                this.ListaVales = [];
                this.ListaFinal = [];
                //this.ListaSecretos= [];
                this.ListaParaVerificar = [];
                this.FechaEnvio=null;
                this.TiuloSobreTabla= null;
                this.TiuloSobreVales = null;
                this.SelEnviar=[];
            }
            comun.SeEstaCargandoInformacion(false);
            })
            .catch(excepcion => {
                console.log(excepcion);
                console.log("fallo por parametros");
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
            });
        
        },
        Imprimir: function(datos, area, bool, vales){
            var Info= this.AreaQueConsulta;
            var Titulo ="";
            if(bool==true)
            {
                Titulo="LISTADO DE DOCUMENTOS PARA ENVÍ0 A SALA DE LECTURA"
            }
            else
            {
                Titulo="LISTADO DE DOCUMENTOS PARA RECEPCIÓN DE SALA DE LECTURA"
            }
            let _this = this;
            var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="col-md-12" padding-div-low" style="display: block; page-break-before: always;">');
            printWin.document.write('   <div class="area">');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-3 align-self-center">');
            printWin.document.write('           <img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('           <div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('               <h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('           <div class="form-group col-3"></div></div></div>');
            printWin.document.write('   <div class="area"><div class="row">');
            printWin.document.write('           <div class="form-group col-12 align-self-center" >');
            printWin.document.write('               <div class="text-center">');
            printWin.document.write('                   <h5 class="text-center">'+ Titulo +'</h5></div>');
            printWin.document.write('               </div></div>');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-12 align-self-center" >');
            printWin.document.write('               <div class="text-center">');
            printWin.document.write('               <h6 class="text-center">FORMATO DE RECEPCIÓN</h6>');
            printWin.document.write('           </div></div></div>');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-12 text-right">');
            printWin.document.write('               <label>Aguascalientes, Ags., a  '+ moment().format('DD/MM/YYYY') + '</label>');
            printWin.document.write('           </div></div>');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-12 ">');
            printWin.document.write('           <label>Area: '+ area.Nombre +'</label>');
            printWin.document.write('       </div></div></div>');
            // Inicio Datos del Listado
            //printWin.document.write('<div class="area">');
            printWin.document.write('   <div class="row">');
            printWin.document.write('       <div class="form-group col-12">');
            printWin.document.write('           <div class="table-reponsive">');
            printWin.document.write('               <table class="table table-striped table-light table-hover table-sm table-bordered" style="page-break-before: auto;">');
            printWin.document.write('                   <thead class="thead-dark" style="display:table-header-group"><tr><th></th><th>Tipo Documento</th><th>Consecutivo</th><th>Contenido</th>');
            printWin.document.write('                       </tr></thead><tbody class="text-dark">');
            $.each(datos, function(index, Lista)
            {
                var CadenaTexto = _this.DesglosaParaImpresion(Lista);
                var row = index +1;
                printWin.document.write('<tr style="page-break-inside:avoid; page-break-after:auto">');
                printWin.document.write('<td width ="100">'+ row +'</td>');
                printWin.document.write('<td width ="400">'+ Lista.TipoDocumento.Nombre +'</td>');
                printWin.document.write('<td width ="200">'+ Lista.Consecutivo +'</td>');
                printWin.document.write('<td>'+ CadenaTexto +'</td>');
                printWin.document.write('</tr>');
            });
            printWin.document.write('</tbody></table></div></div></div>');//</div>');
            // Fin Datos del Listado
            // Inicio Cuadro de Firmas
            printWin.document.write('<div class="row" style="page-break-inside: avoid; page-break-after: auto">');
                        printWin.document.write('<div class="form-group col-1"></div>');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>Nombre Completo</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>' + area.Nombre + '</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-2"></div>');
                        printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
                        printWin.document.write('           <div class="align-self-center"><label><strong>Nombre Completo</strong></label><div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="align-self-center">');
                        printWin.document.write('           <label><strong>SALA DE LECTURA</strong></label></div>');
                        printWin.document.write('       </div>');
                        printWin.document.write('</div>');
                        printWin.document.write('<div class="form-group col-1"></div>');
                        printWin.document.write('</div>');
            // Fin Cuadro de Firmas

            printWin.document.write('</div>');
            if(vales!= null && vales.length>0) //Vales Impresion
            {
                printWin.document.write('<div class="col-md-12" style="display: block; page-break-before: always;">');
                $.each(vales, function(index, lista)
                {
                    var promovido ="";
                    var contra = "";
                    if(lista.Partes!=null && lista.Partes.length>0)
                    {
                        $.each(lista.Partes, function(index, parte)
                        {
                            if(parte.Tipo_Parte=="ACTOR")
                            {
                                promovido= promovido + parte.Nombre + " " + (parte.ApellidoPaterno!=null? parte.ApellidoPaterno : "") +  " " + (parte.ApellidoMaterno!=null? parte.ApellidoMaterno : "") + ", ";
                            }
                            else 
                            {
                                contra= contra + parte.Nombre + " " + (parte.ApellidoPaterno!=null? parte.ApellidoPaterno : "") + " " + (parte.ApellidoMaterno!=null? parte.ApellidoMaterno : "") + ", ";
                            }
                        });
                    }
               
                    printWin.document.write('   <div class="col-12 padding" style="margin-top:0px;margin-bottom:0px; border: 1px solid black; display: block; page-break-inside:avoid; page-break-before: auto;">');
                    printWin.document.write('       <div class="area">');
                    printWin.document.write('           <div class="row text-center">');
                    printWin.document.write('               <div class="form-group col-2 align-self-center">');
                    printWin.document.write('                   <img src="' + LogoPJE +'" width="128" height="104" alt="Logo de Poder Judicial del Estado de Aguascalientes"/>');
                    printWin.document.write('               </div>');
                    printWin.document.write('               <div class="form-group col-10 align-self-center">');
                    printWin.document.write('                   <h3><b>'+ (area.Nombre).toUpperCase() +'</b></h3>');
                    printWin.document.write('               </div>');
                    printWin.document.write('           </div>');
                    printWin.document.write('           <div class="row align-self-center">');
                    printWin.document.write('               <div class="form-group col-12 text-center">');
                    printWin.document.write('                   <h5><b>VALE PARA LA SALA DE LECTURA POR:</b></h5>');
                    printWin.document.write('               </div>');
                    printWin.document.write('           </div>');
                    printWin.document.write('           <div class="row">');
                    printWin.document.write('               <div class="form-group col-4">');
                    printWin.document.write('                   <label><b>EXP. No: </b>' + lista.Consecutivo + '</label>');
                    printWin.document.write('               </div>');
                    printWin.document.write('               <div class="form-group col-4">');
                    printWin.document.write('                   <label><b>FOJAS: </b>__________</label>');
                    printWin.document.write('               </div>');
                    printWin.document.write('               <div class="form-group col-4">');
                    printWin.document.write('                   <label><b>TOMOS: </b> __________</label>');
                    printWin.document.write('               </div>');
                    printWin.document.write('           </div>');
                    printWin.document.write('           <div class="row">');
                    printWin.document.write('               <div class="form-group col-12">');
                    printWin.document.write('                   <label><b>JUICIO: </b>' + (lista.Juicio!=null ? lista.Juicio.Juicio  +', ' : "") + (lista.Juicio !=null?lista.Juicio.Tramite: "" ) +'</label>');
                    printWin.document.write('               </div>');
                    printWin.document.write('           </div>');
                    printWin.document.write('           <div class="row">');
                    printWin.document.write('               <div class="form-group col-12">');
                    printWin.document.write('                   <label><b>PROMOVIDO POR: </b>' + promovido + '</label>');
                    printWin.document.write('               </div>');
                    printWin.document.write('           </div>');
                    printWin.document.write('           <div class="row">');
                    printWin.document.write('               <div class="form-group col-12">');
                    printWin.document.write('                   <label><b>EN CONTRA DE: </b>' + contra + '</label>');
                    printWin.document.write('               </div>');
                    printWin.document.write('           </div>');
                    printWin.document.write('           <div class="row">');
                    printWin.document.write('               <div class="form-group col-1">');
                    printWin.document.write('                   <label><b>LIC: </b> </label>');
                    printWin.document.write('               </div>');
                    printWin.document.write('               <div class="form-group col-8" style="border-bottom: 1px solid black;">');
                    printWin.document.write('               </div>');
                    printWin.document.write('               <div class="form-group col-3">');
                    printWin.document.write('                   <label><b>FECHA: </b>' + moment().format('DD/MM/YYYY') + '</label>');
                    printWin.document.write('               </div>');
                    printWin.document.write('           </div>');
                    printWin.document.write('       </div>');
                    printWin.document.write('   </div>');

                });
                printWin.document.write('</div>');
            }
    
            printWin.document.write('</body></html>');
            var css = '@page { size: Legal;  margin: 25mm 15mm 25mm 15mm; }',
            head = printWin.document.head || document.getElementsByTagName('head')[0],
            style = printWin.document.createElement('style');

            style.type = 'text/css';
            style.media = 'print';

            if (style.styleSheet) {
            style.styleSheet.cssText = css;
            } else {
            style.appendChild(printWin.document.createTextNode(css));
            }
            head.appendChild(style);
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        },
        VerficarContenido(datos){
           
            var listaTemporal =[];
            var ListaIdEquitas = this.ListaParaVerificar;
            $.each(datos, function(index, listado)
            {
                var filtro = ListaIdEquitas.filter(element=>element==listado.DocumentoId_Referencia || element==listado.Volumenes)
                if(filtro.length==1)
                {
                    listaTemporal.push(listado);
                }
            });
            return listaTemporal;
        },
        DesglosaContenido: function (datos){
            var Recepcion = this.ListaRecepcion.length;
            let Contenido ="";
            var materia = datos.Materia;
           
            if(datos.Volumenes!= null && datos.Volumenes.length>0)
            {   
                Contenido = Contenido + "<b class='text-white bg-secondary'>TOMO NO. " + datos.Volumenes[0].NumVolumen + "</b><br/>";
            }
            if(datos.Incidentes!=null && datos.Incidentes.length>0)
            {
                var lineaTexto ="";
                var TituloIncidentes = "";
                var ListaIdEquitas = this.ListaParaVerificar;
                // if (materia.MateriaId!=3)
                // {
                    TituloIncidentes = "<b class='text-white bg-info'>INCIDENTES FUERA DE ENCUADERNADO</b><br/>"
                //}
                var contador = 0;
                $.each(datos.Incidentes, function(index, enVolumen)
                {
                    // if(materia.MateriaId == 3)
                    // {
                        lineaTexto = lineaTexto + "No: "+ enVolumen.NumeroIncidente + ",  Tipo: " + enVolumen.TipoIncidente + "<br/>";
                    //}
                    // else
                    // {
                    //     // var filtro = ListaIdEquitas.filter(element=>element== enVolumen.Incidente_IdReferencia);
                    //     // if(filtro.length == 1 || Recepcion >0)
                    //     // {
                    //         lineaTexto = lineaTexto + "No: "+ enVolumen.NumeroIncidente + ",  Tipo: " + enVolumen.TipoIncidente + "<br/>";
                    //         //contador +=1;
                    //     //}
                    // }
                    
                });
                
                    Contenido = Contenido + TituloIncidentes + lineaTexto;
                // }
                // else
                // {
                //     Contenido = Contenido + lineaTexto
                // }
            }
            if(datos.Tercerias!=null && datos.Tercerias.length>0)
            {
                var lineaTexto ="";
                var ListaIdEquitas = this.ListaParaVerificar;

                $.each(datos.Tercerias, function(index, enVolumen)
                {
                    // var filtro = ListaIdEquitas.filter(element=>element==enVolumen.Terceria_IdReferencia);
                    // if(filtro.length == 1 || Recepcion >0)
                    // {
                        lineaTexto = lineaTexto + "No: "+ enVolumen.NumeroTerceria + ",  Tipo: " + enVolumen.TipoTerceria + "<br/>";
                    //}
                })
                if(lineaTexto!="")
                {
                    Contenido = Contenido + "<b class='text-white bg-success'>TERCERIAS</b><br/>" + lineaTexto
                }
            }
            return Contenido;
        },
        VerificaUbicacion: function(documento){
            this.EnableEnvio = false;
            var fecha = moment().format('YYYY-MM-DD hh:mm:ss');
            var areaIdConsulta = this.AreaQueConsulta.Area.AreaId;
            var usuarioIdConsulta = this.AreaQueConsulta.UsuarioId;
            let UbicacionDiferente = [];
            $.each(documento, function(id, listado)
            {
                console.log(listado)
                if(listado.Movimiento.length>0 && listado.Movimiento!=null)
                {
                    $.each(listado.Movimiento, function (id, elemento)
                    {
                        
                        if(elemento.AreaQueRecibe!=areaIdConsulta)
                        {
                            UbicacionDiferente.push({
                                "VolumenId" : elemento.VolumenId,
                                "FechaMovimiento" : fecha,
                                "FechaRecepcion" : fecha,
                                "FechaRegistro" : fecha,
                                "AreaQuePresta" : {"AreaId" : elemento.AreaQueRecibe},
                                "AreaQueRecibe" : {"AreaId" :areaIdConsulta},
                                "UsuarioQuienPresta" : {"IdUsuario" :elemento.UsuarioQuienRecibe},
                                "UsuarioQuienRecibe" : {"IdUsuario" : usuarioIdConsulta},
                                "UsuarioQuienRegistra" : {"IdUsuario" : usuarioIdConsulta},
                                "TiposMovimientos" : {"TipoMovimientoId" : 2},
                                "SolicitudDocumentoId" : elemento.SolicitudDocumentoId,
                                "ListaAcuerdo" : elemento.ListaAcuerdo,
                                "IncidenteId" : elemento.IncidenteId,
                                "TerceriaId" : elemento.TerceriaId,
                                "AreaExterna" : {"AreaExternaId" : null}
                            })
                        }
                    })
                }
            })
            this.movimientosReubiacion = UbicacionDiferente;
            this.EnableEnvio = true;
        },
        EliminarDocumentoLista(datos){
            var Index = this.ListaFinal.indexOf(datos);
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Desea Eliminar el Documento de la Lista para Envío a Sala de Lectura?<br>Se generara Vale para Sala de Lectura",
                buttons: {
                  cancel: {
                    label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                  },
                  confirm: {
                    label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                  }
                },
                callback: (respuestaSalir) => {
                  if (respuestaSalir) {
                        this.ListaVales.push(this.ListaFinal[Index]);
                        $('#navTabla_Lectura').remove();
                        this.TiuloSobreVales = "Vales a Impresión despues de Envío : " + this.ListaVales.length;
                        this.ListaFinal.splice(Index,1);
                        this.ListaFinal.sort((a,b)=>(a.CodigoBarras>b.CodigoBarras ? 1:-1));
                        this.TiuloSobreTabla = "Total de Elementos en Lista del "+ moment(this.FechaEnvio).format('DD/MM/YYYY') + "  :  " + this.ListaFinal.length

                        this.$nextTick(()=> { PaginarTabla('Tabla_Lectura', 15)});
                           
                  }
                }
              });
        },
        ModificarElementoDeLista(datos){
            var elemento = this.ListaDeDocumentosAcuerdo.filter(e=>e.InventarioDocumentoId == datos);
            this.DocumentoEdicion = elemento[0];
            this.Edicion = true;
        },
        EstatusModal(datos){
            this.Edicion = false;
            
            var InventarioDocumento= datos.InventarioDocumentoId;
            if(datos.InventarioDocumentoId>0)
            {
                var Index= this.ListaFinal.findIndex(e=>e.InventarioDocumentoId==InventarioDocumento);
                
                this.ListaFinal[Index].Volumenes = datos.Volumenes;
                this.ListaFinal[Index].Incidentes= datos.Incidentes;
                this.ListaFinal[Index].Tercerias = datos.Tercerias;
            }
            
        },
        OrganizaTabla(datos){
            var Temporal= [];
            $.each(datos, function(index, lista)
            {
                Temporal.push({
                    "InventarioDocumentoId": lista.InventarioDocumentoId,
                    "TipoDocumento": lista.TipoDocumento,
                    "Materia": lista.Materia,
                    "DocumentoId_Referencia": lista.DocumentoId_Referencia,
                    "Consecutivo": lista.Consecutivo +"/"+lista.Anio,
                    "Juicio": lista.Juicio,
                    "Partes": lista.Partes,
                    "CodigoBarras": lista.CodigoBarras,
                    "Volumenes": lista.Volumenes,
                    "Incidentes": lista.Incidentes,
                    "Tercerias": lista.Tercerias
                })
            })
            return Temporal;
        },
        VerificaRecepcion: function (datos)
        {
            var Area= this.AreaQueConsulta.Area.AreaId
            var CantidadDocumento = datos.length;
            var DocumentosVerificados=0;
            var DocumentosFueraDeArea= 0;
            $.each(datos, function(index, listado)
            {
                var checkVolumenes = false;
                var checkIncidentes = false;
                var checkTercerias = false;
                if(listado.Volumenes.length>0 && listado.Volumenes!=null)
                {
                    $.each(listado.Volumenes, function (index, volumenes){
                            if(volumenes.Area.AreaId!=Area)
                            {
                                DocumentosFueraDeArea = DocumentosFueraDeArea + 1;
                            } 
                    });
                }

                if(listado.Incidentes.length>0 && listado.Incidentes!=null)
                {
                    $.each(listado.Incidentes, function (index, volumenes){
                        
                            if(volumenes.Area.AreaId!=Area)
                            {
                                DocumentosFueraDeArea = DocumentosFueraDeArea + 1;
                            } 
                    })
                }
                if(listado.Tercerias.length>0 && listado.Tercerias!=null)
                {
                    $.each(listado.Tercerias, function (index, volumenes){
                        
                            if(volumenes.Area.AreaId!=Area)
                            {
                                DocumentosFueraDeArea = DocumentosFueraDeArea + 1;
                            } 
                    })
                }
            });
            
            
            if(DocumentosFueraDeArea == 0)
            {
                this.EnableEnvio = true;
            }
            else
            {
                comun.mensajeDeAlerta("Verificar la Ubicación de algunos Elementos para Generar el Envío", null, null);
                this.EnableEnvio = false;
            }
            
        },
        GenerarRecepcion(datos){
            let Movimientos =[]
            var AreaOrigen = this.AreaQueConsulta.Area;
            var AreaReceptora = this.AreaQueConsulta;
            let fechaTexto = moment(this.FechaEnvio).format('DD/MM/YYYY');
            let DocumentosARecibir = this.SeleccionRecepcion();
            if(DocumentosARecibir.length>0)
            {
                $.each(DocumentosARecibir, function(index, listado){
                    Movimientos.push({
                        "MovimientoDocumentoId": listado.MovimientoDocumentoId,
                        "AreaQuePresta": {"AreaId" : listado.AreaQueRecibe},
                        "AreaQueRecibe": {"AreaId" : listado.AreaQuePresta },
                        "UsuarioQuienPresta": {"IdUsuario" : null},
                        "UsuarioQuienRecibe": {"IdUsuario" : listado.UsuarioQuienPresta},
                        "VolumenId": listado.VolumenId,
                        "TerceriaId": listado.TerceriaId,
                        "IncidenteId": listado.IncidenteId,
                        "Observaciones": "Devolución de Sala de Lectura a " + AreaReceptora.Area.Nombre + ", enviado el " + fechaTexto,
                        "ListaAcuerdo": null,
                        "TiposMovimientos": {"TipoMovimientoId": 2}
                        })
                    });
                var peticion={
                    Movimientos
                };
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.ArchivoJudicial.RecepcionSala, peticion,
                  comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then( respuesta => {
                  if(respuesta.data.SiHayError)
                    {
                      console.log(respuesta);
                      comun.SeEstaCargandoInformacion(false);
                      comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    }
                    else
                    {   
                        $('#navTabla_Lectura').remove();
                        $('#navTable_Secretos').remove();
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta("Los Documentos fueron recibidos en sistéma.", null, null);
                        this.Parcial = [];
                        this.ListaRecepcion = [];
                        this.ListaFinal=[];
                        this.EnvioSala = false;
                        this.TiuloSobreTabla= null;
                        this.TiuloSobreSecretos = null;
                        this.FechaEnvio=null;
                        
                    }
                    comun.SeEstaCargandoInformacion(false);
                    })
                .catch(excepcion => {
                    console.log(excepcion);
                    console.log("fallo por parametros");
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                    });
            }
            else
            {
                comun.mensajeDeAlerta("Seleccione Documento(s) para recepción", null, null);
            }
            
        },
        OrganizaRecepcion(datos){
            let Documentos =[];
            $.each(datos, function(index, listado)
            {
                if(listado.VolumenId!=null)
                {
                    var ExisteDocumentoEnLista = Documentos.find(e=>e.InventarioDocumentoId==listado.Volumen.Inventario.InventarioDocumentoId);
                    if(ExisteDocumentoEnLista==undefined || ExisteDocumentoEnLista== false)
                    {
                        Documentos.push({
                            "InventarioDocumentoId": listado.Volumen.Inventario.InventarioDocumentoId,
                            "TipoDocumento": listado.Volumen.Inventario.TipoDocumento,
                            "Materia": listado.Volumen.Inventario.Materia,
                            "DocumentoId_Referencia": listado.Volumen.Inventario.DocumentoId_Referencia,
                            "Consecutivo": listado.Volumen.Inventario.Consecutivo +"/"+listado.Volumen.Inventario.Anio,
                            "CodigoBarras": listado.Volumen.Inventario.CodigoBarras,
                            "Volumenes": [],
                            "Incidentes": [],
                            "Tercerias":[]
                        })
                        var indice = Documentos.findIndex(e=>e.InventarioDocumentoId==listado.Volumen.Inventario.InventarioDocumentoId);
                        Documentos[indice].Volumenes.push(listado.Volumen)
                    }
                    else
                    {
                        ExisteDocumentoEnLista.Volumenes.push(listado.Volumen);
                    }
                };
                if(listado.IncidenteId!=null)
                {   
                    var ExisteDocumentoEnLista = Documentos.find(e=>e.InventarioDocumentoId==listado.Incidente.Inventario.InventarioDocumentoId);
                    if(ExisteDocumentoEnLista==undefined || ExisteDocumentoEnLista== false)
                    {
                        Documentos.push({
                            "InventarioDocumentoId": listado.Incidente.Inventario.InventarioDocumentoId,
                            "TipoDocumento": listado.Incidente.Inventario.TipoDocumento,
                            "Materia": listado.Incidente.Inventario.Materia,
                            "DocumentoId_Referencia": listado.Incidente.Inventario.DocumentoId_Referencia,
                            "Consecutivo": listado.Incidente.Inventario.Consecutivo + "/" + listado.Incidente.Inventario.Anio,
                            "CodigoBarras": listado.Incidente.Inventario.CodigoBarras,
                            "Volumenes": [],
                            "Incidentes": [],
                            "Tercerias":[]
                        })
                        var indice = Documentos.findIndex(e=>e.InventarioDocumentoId==listado.Incidente.Inventario.InventarioDocumentoId);
                        Documentos[indice].Incidentes.push(listado.Incidente)
                    }
                    else
                    {
                        ExisteDocumentoEnLista.Incidentes.push(listado.Incidente);
                    }
                };
                if(listado.TerceriaId!=null)
                {
                    var ExisteDocumentoEnLista = Documentos.find(e=>e.InventarioDocumentoId==listado.Terceria.Inventario.InventarioDocumentoId);
                    if(ExisteDocumentoEnLista==undefined || ExisteDocumentoEnLista== false)
                    {
                        Documentos.push({
                            "InventarioDocumentoId": listado.Terceria.Inventario.InventarioDocumentoId,
                            "TipoDocumento": listado.Terceria.Inventario.TipoDocumento,
                            "Materia": listado.Terceria.Inventario.Materia,
                            "DocumentoId_Referencia": listado.Terceria.Inventario.DocumentoId_Referencia,
                            "Consecutivo": listado.Terceria.Inventario.Consecutivo +"/"+listado.Terceria.Inventario.Anio,
                            "CodigoBarras": listado.Terceria.Inventario.CodigoBarras,
                            "Volumenes": [],
                            "Incidentes": [],
                            "Tercerias":[]
                        })
                        var indice = Documentos.findIndex(e=>e.InventarioDocumentoId==listado.Terceria.Inventario.InventarioDocumentoId);
                        Documentos[indice].Tercerias.push(listado.Terceria)
                    }
                    else
                    {
                        ExisteDocumentoEnLista.Tercerias.push(listado.Terceria);
                    }
                }
            });
            return Documentos;
        },
        DesglosaParaImpresion: function (datos) {
            let Contenido ="";
            var TipoDoc= datos.TipoDocumento.TipoDocumentoId;
            if(datos.Volumenes.length>0)
            {   
                $.each(datos.Volumenes, function(index, Listado)
                {
                    Contenido = Contenido + "<b>VOLUMEN NO. </b>" + Listado.NumVolumen + "<br/>" ;
                });
            };
            if(datos.Incidentes.length>0)
            {
                $.each(datos.Incidentes, function(index, enVolumen)
                {
                    
                    Contenido = Contenido + "<b>INCIDENTE NO. </b>" + enVolumen.NumeroIncidente + " <br/>";
                });
            }
            if(datos.Tercerias.length>0)
            {
                $.each(datos.Tercerias, function(index, enVolumen)
                {
                    Contenido = Contenido + "<b>TERCERIA NO.</b>"+ enVolumen.NumeroTerceria + "<br/>";
                });
            }
            return Contenido;
        },
        SelectAll(evento){
            this.Parcial= [];
            if(this.SeleccionarTodos != false)
            {
                for (let i in this.ListaFinal)
                {
                    this.Parcial.push(this.ListaFinal[i].InventarioDocumentoId)
                }
            };
        },
        SeleccionRecepcion(){
            let documentosSeleccionados = [];
            this.Parcial.forEach((element) =>{
                let agregaDocumento = this.ListaFinal.filter(mov=>(mov.InventarioDocumentoId == element));
                if(agregaDocumento.length>0)
                {
                    $.each(agregaDocumento[0].Movimiento, function( index, movimiento)
                    {
                        documentosSeleccionados.push(movimiento);
                    })
                }
            });
            return documentosSeleccionados;
        },
        SelectTodosEnvios(){
            for (let i in this.ListaFinal)
            {
                this.SelEnviar.push(this.ListaFinal[i].InventarioDocumentoId)
            };
        },
        ObtenerSeleccionados(datos){
            let documentosSeleccionados = [];
            this.SelEnviar.forEach((element) =>{
                let agregaDocumento = datos.filter(mov=>mov.InventarioDocumentoId==element);
                if(agregaDocumento.length>0)
                {
                    $.each(agregaDocumento[0].Movimiento, function( index, movimiento)
                    {
                        documentosSeleccionados.push(movimiento);
                    })
                }
            });
            return documentosSeleccionados;
        },
        checkDocumento(event){
            setTimeout(()=>{
                //console.log(this.SelEnviar)
                this.TiuloSobreTabla = "Lista del "+ moment(this.FechaEnvio).format('DD/MM/YYYY') + ", Total de Documentos para Envío:  " + this.SelEnviar.length
            },200);
        },
        OrganizaVolumenes(datos, incidentes, tercerias) {
            let Documentos =[];
            $.each(datos, function(index, listado)
            {
                if(listado.VolumenId!=null)
                {
                    var ExisteDocumentoEnLista = Documentos.find(e=>e.InventarioDocumentoId==listado.InventarioDocumentoId);
                    if(ExisteDocumentoEnLista==undefined || ExisteDocumentoEnLista== false)
                    {
                        Documentos.push({
                            "InventarioDocumentoId": listado.InventarioDocumentoId,
                            "TipoDocumentoId": listado.TipoDocumentoId,
                            "MateriaId": listado.MateriaId,
                            //"DocumentoId_Referencia": listado.Volumen.Inventario.DocumentoId_Referencia,
                            "Consecutivo": listado.Consecutivo +"/"+listado.Anio,
                            "CodigoBarras": listado.CodigoBarras,
                            "Movimiento": [],
                            "Volumenes": [],
                            "Incidentes": [],
                            "Tercerias":[]
                        })
                        var indice = Documentos.findIndex(e=>e.InventarioDocumentoId==listado.InventarioDocumentoId);
                        Documentos[indice].Movimiento.push({
                            "MovimientoDocumentoId" : listado.MovimientoDocumentoId,
                            "VolumenId" : listado.VolumenId,
                            "FechaMovimiento" : listado.FechaMovimiento,
                            "FechaRecepcion" : listado.FechaRecepcion,
                            "FechaRegistro" : listado.FechaRegistro,
                            "AreaQuePresta" : listado.AreaQuePresta,
                            "AreaQueRecibe" : listado.AreaQueRecibe,
                            "UsuarioQuienPresta" : listado.UsuarioQuienPresta,
                            "UsuarioQuienRecibe" : listado.UsuarioQuienRecibe,
                            "UsuarioQuienRegistra" : listado.UsuarioQuienRegistra,
                            "TipoMovimientoId" : listado.TipoMovimientoId,
                            "SolicitudDocumentoId" : listado.SolicitudDocumentoId,
                            "ListaAcuerdo" : listado.ListaAcuerdo,
                            "IncidenteId" : listado.IncidenteId,
                            "TerceriaId" : listado.TerceriaId,
                            "AreaExternaId": listado.AreaExternaId
                        });
                        Documentos[indice].Volumenes.push({
                            "VolumenId" : listado.VolumenId,
                            "NumVolumen" : listado.NumVolumen,
                            "Area": { "AreaId" : listado.AreaVolumen, "Nombre": ""},
                            "InventarioDocumentoId": listado.InventarioDocumentoId
                        })
                    }
                    else
                    {
                        ExisteDocumentoEnLista.Volumenes.push({
                            "InventarioDocumentoId": listado.InventarioDocumentoId,
                            "VolumenId" : listado.VolumenId,
                            "NumVolumen" : listado.NumVolumen,
                            "Area": { "AreaId" : listado.AreaVolumen, "Nombre": ""}
                        });
                        ExisteDocumentoEnLista.Movimiento.push({
                            "MovimientoDocumentoId" : listado.MovimientoDocumentoId,
                            "VolumenId" : listado.VolumenId,
                            "FechaMovimiento" : listado.FechaMovimiento,
                            "FechaRecepcion" : listado.FechaRecepcion,
                            "FechaRegistro" : listado.FechaRegistro,
                            "AreaQuePresta" : listado.AreaQuePresta,
                            "AreaQueRecibe" : listado.AreaQueRecibe,
                            "UsuarioQuienPresta" : listado.UsuarioQuienPresta,
                            "UsuarioQuienRecibe" : listado.UsuarioQuienRecibe,
                            "UsuarioQuienRegistra" : listado.UsuarioQuienRegistra,
                            "TipoMovimientoId" : listado.TipoMovimientoId,
                            "SolicitudDocumentoId" : listado.SolicitudDocumentoId,
                            "ListaAcuerdo" : listado.ListaAcuerdo,
                            "IncidenteId" : listado.IncidenteId,
                            "TerceriaId" : listado.TerceriaId,
                            "AreaExterna": listado.AreaExterna
                        })
                    }
                };

            });
            
            
            $.each(tercerias, function(index, listado)
            {
                if(listado.TerceriaId!=null)
                {
                    var ExisteDocumentoEnLista = Documentos.find(e=>e.InventarioDocumentoId==listado.InventarioDocumentoId);
                    if(ExisteDocumentoEnLista==undefined || ExisteDocumentoEnLista== false)
                    {
                        Documentos.push({
                            "InventarioDocumentoId": listado.InventarioDocumentoId,
                            "TipoDocumentoId": listado.TipoDocumentoId,
                            "MateriaId": listado.MateriaId,
                            //"DocumentoId_Referencia": listado.Volumen.Inventario.DocumentoId_Referencia,
                            "Consecutivo": listado.Consecutivo +"/"+listado.Anio,
                            "CodigoBarras": listado.CodigoBarras,
                            "Movimiento": [],
                            "Volumenes": [],
                            "Incidentes": [],
                            "Tercerias":[]
                        })
                        var indice = Documentos.findIndex(e=>e.InventarioDocumentoId==listado.InventarioDocumentoId);
                        Documentos[indice].Movimiento.push({
                            "MovimientoDocumentoId" : listado.MovimientoDocumentoId,
                            "VolumenId" : listado.VolumenId,
                            "FechaMovimiento" : listado.FechaMovimiento,
                            "FechaRecepcion" : listado.FechaRecepcion,
                            "FechaRegistro" : listado.FechaRegistro,
                            "AreaQuePresta" : listado.AreaQuePresta,
                            "AreaQueRecibe" : listado.AreaQueRecibe,
                            "UsuarioQuienPresta" : listado.UsuarioQuienPresta,
                            "UsuarioQuienRecibe" : listado.UsuarioQuienRecibe,
                            "UsuarioQuienRegistra" : listado.UsuarioQuienRegistra,
                            "TipoMovimientoId" : listado.TipoMovimientoId,
                            "SolicitudDocumentoId" : listado.SolicitudDocumentoId,
                            "ListaAcuerdo" : listado.ListaAcuerdo,
                            "IncidenteId" : listado.IncidenteId,
                            "TerceriaId" : listado.TerceriaId,
                            "AreaExternaId": listado.AreaExternaId
                        });
                        Documentos[indice].Tercerias.push({
                            "InventarioDocumentoId": listado.InventarioDocumentoId,
                            "TerceriaId" : listado.VolumenId,
                            "NumeroTerceria" : listado.NumTerceria,
                            "TipoTerceria" : listado.TipoTerceria,
                            "Area": { "AreaId" : listado.AreaTerceria, "Nombre": ""}
                        })
                    }
                    else
                    {
                        ExisteDocumentoEnLista.Tercerias.push({
                            "InventarioDocumentoId": listado.InventarioDocumentoId,
                            "TerceriaId" : listado.VolumenId,
                            "NumeroTerceria" : listado.NumTerceria,
                            "TipoTerceria" : listado.TipoTerceria,
                            "Area": { "AreaId" : listado.AreaTerceria, "Nombre": ""}
                        });
                        ExisteDocumentoEnLista.Movimiento.push({
                            "MovimientoDocumentoId" : listado.MovimientoDocumentoId,
                            "VolumenId" : listado.VolumenId,
                            "FechaMovimiento" : listado.FechaMovimiento,
                            "FechaRecepcion" : listado.FechaRecepcion,
                            "FechaRegistro" : listado.FechaRegistro,
                            "AreaQuePresta" : listado.AreaQuePresta,
                            "AreaQueRecibe" : listado.AreaQueRecibe,
                            "UsuarioQuienPresta" : listado.UsuarioQuienPresta,
                            "UsuarioQuienRecibe" : listado.UsuarioQuienRecibe,
                            "UsuarioQuienRegistraS" : listado.UsuarioQuienRegistra,
                            "TipoMovimientoId" : listado.TipoMovimientoId,
                            "SolicitudDocumentoId" : listado.SolicitudDocumentoId,
                            "ListaAcuerdo" : listado.ListaAcuerdo,
                            "IncidenteId" : listado.IncidenteId,
                            "TerceriaId" : listado.TerceriaId,
                            "AreaExternaId": listado.AreaExternaId
                        })
                    }
                };

            });
            
            $.each(incidentes, function(index, listadoIncidente)
            {
                if(listadoIncidente.IncidenteId!=null)
                {
                    var ExisteDocumentoEnLista = Documentos.find(e=>e.InventarioDocumentoId==listadoIncidente.InventarioDocumentoId);
                    if(ExisteDocumentoEnLista==undefined || ExisteDocumentoEnLista== false)
                    {
                        Documentos.push({
                            "InventarioDocumentoId": listadoIncidente.InventarioDocumentoId,
                            "TipoDocumentoId": listadoIncidente.TipoDocumentoId,
                            "MateriaId": listadoIncidente.MateriaId,
                            //"DocumentoId_Referencia": listado.Volumen.Inventario.DocumentoId_Referencia,
                            "Consecutivo": listadoIncidente.Consecutivo +"/"+listadoIncidente.Anio,
                            "CodigoBarras": listadoIncidente.CodigoBarras,
                            "Movimiento": [],
                            "Volumenes": [],
                            "Incidentes": [],
                            "Tercerias":[]
                        })
                        var indice = Documentos.findIndex(e=>e.InventarioDocumentoId==listadoIncidente.InventarioDocumentoId);
                        Documentos[indice].Movimiento.push({
                            "MovimientoDocumentoId" : listadoIncidente.MovimientoDocumentoId,
                            "VolumenId" : listadoIncidente.VolumenId,
                            "FechaMovimiento" : listadoIncidente.FechaMovimiento,
                            "FechaRecepcion" : listadoIncidente.FechaRecepcion,
                            "FechaRegistro" : listadoIncidente.FechaRegistro,
                            "AreaQuePresta" : listadoIncidente.AreaQuePresta,
                            "AreaQueRecibe" : listadoIncidente.AreaQueRecibe,
                            "UsuarioQuienPresta" : listadoIncidente.UsuarioQuienPresta,
                            "UsuarioQuienRecibe" : listadoIncidente.UsuarioQuienRecibe,
                            "UsuarioQuienRegistra" : listadoIncidente.UsuarioQuienRegistra,
                            "TipoMovimientoId" : listadoIncidente.TipoMovimientoId,
                            "SolicitudDocumentoId" : listadoIncidente.SolicitudDocumentoId,
                            "ListaAcuerdo" : listadoIncidente.ListaAcuerdo,
                            "IncidenteId" : listadoIncidente.IncidenteId,
                            "TerceriaId" : listadoIncidente.TerceriaId,
                            "AreaExternaId": listadoIncidente.AreaExternaId
                        });
                        Documentos[indice].Incidentes.push({
                            "InventarioDocumentoId": listadoIncidente.InventarioDocumentoId,
                            "IncidenteId" : listadoIncidente.IncidenteId,
                            "NumeroIncidente" : listadoIncidente.NumIncidente,
                            "TipoIncidente": listadoIncidente.TipoIncidente,
                            "Area": { "AreaId" : listadoIncidente.AreaIncidente, "Nombre": ""}
                        })
                    }
                    else
                    {
                        ExisteDocumentoEnLista.Incidentes.push({
                            "InventarioDocumentoId": listadoIncidente.InventarioDocumentoId,
                            "IncidenteId" : listadoIncidente.IncidenteId,
                            "NumeroIncidente" : listadoIncidente.NumIncidente,
                            "TipoIncidente": listadoIncidente.TipoIncidente,
                            "Area": { "AreaId" : listadoIncidente.AreaIncidente, "Nombre": ""}
                        });
                        ExisteDocumentoEnLista.Movimiento.push({
                            "MovimientoDocumentoId" : listadoIncidente.MovimientoDocumentoId,
                            "VolumenId" : listadoIncidente.VolumenId,
                            "FechaMovimiento" : listadoIncidente.FechaMovimiento,
                            "FechaRecepcion" : listadoIncidente.FechaRecepcion,
                            "FechaRegistro" : listadoIncidente.FechaRegistro,
                            "AreaQuePresta" : listadoIncidente.AreaQuePresta,
                            "AreaQueRecibe" : listadoIncidente.AreaQueRecibe,
                            "UsuarioQuienPresta" : listadoIncidente.UsuarioQuienPresta,
                            "UsuarioQuienRecibe" : listadoIncidente.UsuarioQuienRecibe,
                            "UsuarioQuienRegistra" : listadoIncidente.UsuarioQuienRegistra,
                            "TipoMovimientoId" : listadoIncidente.TipoMovimientoId,
                            "SolicitudDocumentoId" : listadoIncidente.SolicitudDocumentoId,
                            "ListaAcuerdo" : listadoIncidente.ListaAcuerdo,
                            "IncidenteId" : listadoIncidente.IncidenteId,
                            "TerceriaId" : listadoIncidente.TerceriaId,
                            "AreaExternaId": listadoIncidente.AreaExternaId
                        })
                    }
                };

            });
            return Documentos;
        },
        TipoDocumentoHTML(tipo) {
            let TipoDocumento = ''
            switch(tipo)
            {
                case 1: 
                TipoDocumento = "EXPEDIENTE PRINCIPAL";
                break;
                case 2: 
                TipoDocumento = "TERCERÍA";
                break;
                case 4: 
                TipoDocumento = "CUADERNO DE AMPARO";
                break;
                case 5: 
                TipoDocumento = "EXHORTO";
                break;
                case 6: 
                TipoDocumento = "REQUISITORIA";
                break;
                case 10: 
                TipoDocumento = "INCIDENTE";
                break;
                case 5: 
                TipoDocumento = "ROGATORIA";
                break;
                case 5: 
                TipoDocumento = "DESPACHO";
                break;
            };
            return TipoDocumento;
        },
        OrganizaParaRecepcion(datos)
        {
            let Documentos =[];
            datos.forEach((listado)=>{
                if(listado.VolumenId!=null)
                {
                    var ExisteDocumentoEnLista = Documentos.find(e=>e.InventarioDocumentoId==listado.InventarioDocumentoId);
                    if(ExisteDocumentoEnLista==undefined || ExisteDocumentoEnLista== false)
                    {
                        Documentos.push({
                            "InventarioDocumentoId": listado.InventarioDocumentoId,
                            "TipoDocumentoId": listado.TipoDocumentoId,
                            "MateriaId": listado.MateriaId,
                            //"DocumentoId_Referencia": listado.Volumen.Inventario.DocumentoId_Referencia,
                            "Consecutivo": listado.Consecutivo +"/"+listado.Anio,
                            "CodigoBarras": listado.CodigoBarras,
                            "Movimiento": [],
                            "Volumenes": [],
                            "Incidentes": [],
                            "Tercerias":[]
                        })
                        var indice = Documentos.findIndex(e=>e.InventarioDocumentoId==listado.InventarioDocumentoId);
                        Documentos[indice].Movimiento.push({
                            "MovimientoDocumentoId" : listado.MovimientoDocumentoId,
                            "VolumenId" : listado.VolumenId,
                            "FechaMovimiento" : listado.FechaMovimiento,
                            "FechaRecepcion" : listado.FechaRecepcion,
                            "FechaRegistro" : listado.FechaRegistro,
                            "AreaQuePresta" : listado.AreaQuePresta,
                            "AreaQueRecibe" : listado.AreaQueRecibe,
                            "UsuarioQuienPresta" : listado.UsuarioQuienPresta,
                            "UsuarioQuienRecibe" : listado.UsuarioQuienRecibe,
                            "UsuarioQuienRegistra" : listado.UsuarioQuienRegistra,
                            "TipoMovimientoId" : listado.TipoMovimientoId,
                            "SolicitudDocumentoId" : listado.SolicitudDocumentoId,
                            "ListaAcuerdo" : listado.ListaAcuerdo,
                            "IncidenteId" : listado.IncidenteId,
                            "TerceriaId" : listado.TerceriaId
                        });
                        Documentos[indice].Volumenes.push({
                            "VolumenId" : listado.VolumenId,
                            "NumVolumen" : listado.NumVolumen,
                            "Area": { "AreaId" : listado.AreaVolumen, "Nombre": ""},
                            "InventarioDocumentoId": listado.InventarioDocumentoId
                        })
                    }
                    else
                    {
                        ExisteDocumentoEnLista.Volumenes.push({
                            "InventarioDocumentoId": listado.InventarioDocumentoId,
                            "VolumenId" : listado.VolumenId,
                            "NumVolumen" : listado.NumVolumen,
                            "Area": { "AreaId" : listado.AreaVolumen, "Nombre": ""}
                        });
                        ExisteDocumentoEnLista.Movimiento.push({
                            "MovimientoDocumentoId" : listado.MovimientoDocumentoId,
                            "VolumenId" : listado.VolumenId,
                            "FechaMovimiento" : listado.FechaMovimiento,
                            "FechaRecepcion" : listado.FechaRecepcion,
                            "FechaRegistro" : listado.FechaRegistro,
                            "AreaQuePresta" : listado.AreaQuePresta,
                            "AreaQueRecibe" : listado.AreaQueRecibe,
                            "UsuarioQuienPresta" : listado.UsuarioQuienPresta,
                            "UsuarioQuienRecibe" : listado.UsuarioQuienRecibe,
                            "UsuarioQuienRegistra" : listado.UsuarioQuienRegistra,
                            "TipoMovimientoId" : listado.TipoMovimientoId,
                            "SolicitudDocumentoId" : listado.SolicitudDocumentoId,
                            "ListaAcuerdo" : listado.ListaAcuerdo,
                            "IncidenteId" : listado.IncidenteId,
                            "TerceriaId" : listado.TerceriaId,
                        })
                    }
                };

                if(listado.IncidenteId!=null)
                {
                        var ExisteDocumentoEnLista = Documentos.find(e=>e.InventarioDocumentoId==listado.InventarioDocumentoId);
                        if(ExisteDocumentoEnLista==undefined || ExisteDocumentoEnLista== false)
                        {
                            Documentos.push({
                                "InventarioDocumentoId": listado.InventarioDocumentoId,
                                "TipoDocumentoId": listado.TipoDocumentoId,
                                "MateriaId": listado.MateriaId,
                                //"DocumentoId_Referencia": listado.Volumen.Inventario.DocumentoId_Referencia,
                                "Consecutivo": listado.Consecutivo +"/"+listado.Anio,
                                "CodigoBarras": listado.CodigoBarras,
                                "Movimiento": [],
                                "Volumenes": [],
                                "Incidentes": [],
                                "Tercerias":[]
                            })
                            var indice = Documentos.findIndex(e=>e.InventarioDocumentoId==listado.InventarioDocumentoId);
                            Documentos[indice].Movimiento.push({
                                "MovimientoDocumentoId" : listado.MovimientoDocumentoId,
                                "VolumenId" : listado.VolumenId,
                                "FechaMovimiento" : listado.FechaMovimiento,
                                "FechaRecepcion" : listado.FechaRecepcion,
                                "FechaRegistro" : listado.FechaRegistro,
                                "AreaQuePresta" : listado.AreaQuePresta,
                                "AreaQueRecibe" : listado.AreaQueRecibe,
                                "UsuarioQuienPresta" : listado.UsuarioQuienPresta,
                                "UsuarioQuienRecibe" : listado.UsuarioQuienRecibe,
                                "UsuarioQuienRegistra" : listado.UsuarioQuienRegistra,
                                "TipoMovimientoId" : listado.TipoMovimientoId,
                                "SolicitudDocumentoId" : listado.SolicitudDocumentoId,
                                "ListaAcuerdo" : listado.ListaAcuerdo,
                                "IncidenteId" : listado.IncidenteId,
                                "TerceriaId" : listado.TerceriaId
                            });
                            Documentos[indice].Incidentes.push({
                                "InventarioDocumentoId": listado.InventarioDocumentoId,
                                "IncidenteId" : listado.IncidenteId,
                                "NumeroIncidente" : listado.NumIncidente,
                                "TipoIncidente": listado.TipoIncidente,
                                "Area": { "AreaId" : listado.AreaIncidente, "Nombre": ""}
                            })
                        }
                        else
                        {
                            ExisteDocumentoEnLista.Incidentes.push({
                                "InventarioDocumentoId": listado.InventarioDocumentoId,
                                "IncidenteId" : listado.IncidenteId,
                                "NumeroIncidente" : listado.NumIncidente,
                                "TipoIncidente": listado.TipoIncidente,
                                "Area": { "AreaId" : listado.AreaIncidente, "Nombre": ""}
                            });
                            ExisteDocumentoEnLista.Movimiento.push({
                                "MovimientoDocumentoId" : listado.MovimientoDocumentoId,
                                "VolumenId" : listado.VolumenId,
                                "FechaMovimiento" : listado.FechaMovimiento,
                                "FechaRecepcion" : listado.FechaRecepcion,
                                "FechaRegistro" : listado.FechaRegistro,
                                "AreaQuePresta" : listado.AreaQuePresta,
                                "AreaQueRecibe" : listado.AreaQueRecibe,
                                "UsuarioQuienPresta" : listado.UsuarioQuienPresta,
                                "UsuarioQuienRecibe" : listado.UsuarioQuienRecibe,
                                "UsuarioQuienRegistra" : listado.UsuarioQuienRegistra,
                                "TipoMovimientoId" : listado.TipoMovimientoId,
                                "SolicitudDocumentoId" : listado.SolicitudDocumentoId,
                                "ListaAcuerdo" : listado.ListaAcuerdo,
                                "IncidenteId" : listado.IncidenteId,
                                "TerceriaId" : listado.TerceriaId
                            })
                        }
                }

                if(listado.TerceriaId!=null)
                {
                        var ExisteDocumentoEnLista = Documentos.find(e=>e.InventarioDocumentoId==listado.InventarioDocumentoId);
                        if(ExisteDocumentoEnLista==undefined || ExisteDocumentoEnLista== false)
                        {
                            Documentos.push({
                                "InventarioDocumentoId": listado.InventarioDocumentoId,
                                "TipoDocumentoId": listado.TipoDocumentoId,
                                "MateriaId": listado.MateriaId,
                                //"DocumentoId_Referencia": listado.Volumen.Inventario.DocumentoId_Referencia,
                                "Consecutivo": listado.Consecutivo +"/"+listado.Anio,
                                "CodigoBarras": listado.CodigoBarras,
                                "Movimiento": [],
                                "Volumenes": [],
                                "Incidentes": [],
                                "Tercerias":[]
                            })
                            var indice = Documentos.findIndex(e=>e.InventarioDocumentoId==listado.InventarioDocumentoId);
                            Documentos[indice].Movimiento.push({
                                "MovimientoDocumentoId" : listado.MovimientoDocumentoId,
                                "VolumenId" : listado.VolumenId,
                                "FechaMovimiento" : listado.FechaMovimiento,
                                "FechaRecepcion" : listado.FechaRecepcion,
                                "FechaRegistro" : listado.FechaRegistro,
                                "AreaQuePresta" : listado.AreaQuePresta,
                                "AreaQueRecibe" : listado.AreaQueRecibe,
                                "UsuarioQuienPresta" : listado.UsuarioQuienPresta,
                                "UsuarioQuienRecibe" : listado.UsuarioQuienRecibe,
                                "UsuarioQuienRegistra" : listado.UsuarioQuienRegistra,
                                "TipoMovimientoId" : listado.TipoMovimientoId,
                                "SolicitudDocumentoId" : listado.SolicitudDocumentoId,
                                "ListaAcuerdo" : listado.ListaAcuerdo,
                                "IncidenteId" : listado.IncidenteId,
                                "TerceriaId" : listado.TerceriaId
                            });
                            Documentos[indice].Tercerias.push({
                                "InventarioDocumentoId": listado.InventarioDocumentoId,
                                "TerceriaId" : listado.VolumenId,
                                "NumeroTerceria" : listado.NumTerceria,
                                "TipoTerceria" : listado.TipoTerceria,
                                "Area": { "AreaId" : listado.AreaTerceria, "Nombre": ""}
                            })
                        }
                        else
                        {
                            ExisteDocumentoEnLista.Tercerias.push({
                                "InventarioDocumentoId": listado.InventarioDocumentoId,
                                "TerceriaId" : listado.VolumenId,
                                "NumeroTerceria" : listado.NumTerceria,
                                "TipoTerceria" : listado.TipoTerceria,
                                "Area": { "AreaId" : listado.AreaTerceria, "Nombre": ""}
                            });
                            ExisteDocumentoEnLista.Movimiento.push({
                                "MovimientoDocumentoId" : listado.MovimientoDocumentoId,
                                "VolumenId" : listado.VolumenId,
                                "FechaMovimiento" : listado.FechaMovimiento,
                                "FechaRecepcion" : listado.FechaRecepcion,
                                "FechaRegistro" : listado.FechaRegistro,
                                "AreaQuePresta" : listado.AreaQuePresta,
                                "AreaQueRecibe" : listado.AreaQueRecibe,
                                "UsuarioQuienPresta" : listado.UsuarioQuienPresta,
                                "UsuarioQuienRecibe" : listado.UsuarioQuienRecibe,
                                "UsuarioQuienRegistraS" : listado.UsuarioQuienRegistra,
                                "TipoMovimientoId" : listado.TipoMovimientoId,
                                "SolicitudDocumentoId" : listado.SolicitudDocumentoId,
                                "ListaAcuerdo" : listado.ListaAcuerdo,
                                "IncidenteId" : listado.IncidenteId,
                                "TerceriaId" : listado.TerceriaId,
                            })
                        }
                };

            })
            return Documentos;
        },
        MoverSecretos(datos){
            
            var Area = this.AreaQueConsulta.Area.AreaId;
            var Usuario = this.AreaQueConsulta.UsuarioId;
            this.movimientosReubiacion = [];
            //this.VerificaUbicacion(datos);
            let MovimientosDocumentos= [];
            let Secretos = [];
            $.each(datos, function(index, documento)
            {
                $.each(documento.Movimiento, function(x, listado)
                {   
                    if(listado.UsuarioQuienRecibe!=Usuario)
                    {
                        Secretos.push({
                            "VolumenId": listado.VolumenId!=null ? listado.VolumenId: null ,
                            "IncidenteId": listado.IncidenteId!=null ? listado.IncidenteId: null,
                            "TerceriaId": listado.TerceriaId!=null ?listado.TerceriaId: null,
                            "FechaMovimiento": null,
                            "UsuarioQuienPresta" :{"IdUsuario":listado.UsuarioQuienRecibe},
                            "UsuarioQuienRecibe" :{"IdUsuario": Usuario},
                            "AreaQuePresta": {"AreaId": listado.AreaQuePresta},
                            "AreaQueRecibe": {"AreaId": Area},
                            "AreaExterna": null,
                            "SolicitudDocumentoId" : null,
                            "FechaRecepcion": null,
                            "ListaAcuerdo": null,
                            "Observaciones" : "Movimiento por asiganción por acuerdo secreto."}
                        );
                    }
                    
                })
                    
            });
            let Reubicacion = this.movimientosReubiacion;
            var peticion = { MovimientosDocumentos, Reubicacion, Secretos, "AreaId": Area};
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.EnvioSalaLectura, peticion, comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
            if(respuesta.data.SiHayError)
            {
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            }
            else
            {  
                let _this = this;
                $('#navTabla_Lectura').remove();
                $('#navTable_Secretos').remove();
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta("Los documentos fueros asignados al usuario en sesión", null, null);
                this.ListaDeDocumentosAcuerdo=[];
                this.ListaVales = [];
                this.ListaFinal = [];
                this.ListaSecretos= [];
                this.ListaParaVerificar = [];
                this.FechaEnvio=null;
                this.TiuloSobreTabla= null;
                this.TiuloSobreVales = null;
                this.SelEnviar=[];
                this.EnviarSecretos = false;

            }
            comun.SeEstaCargandoInformacion(false);
            })
            .catch(excepcion => {
                console.log(excepcion);
                console.log("fallo por parametros");
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
            });
        },
        VerificaElementoFueraParaTabla(datos)
        {
            let Consecutivo = ''
            if(datos.Movimiento==null)
            {
                Consecutivo = '<label class=text-danger>' + datos.Consecutivo + '</label>'
            }
            if(datos.Movimiento!=null && datos.Movimiento[0].AreaQueRecibe==this.AreaQueConsulta.Area.AreaId && datos.Movimiento[0].FechaRecepcion!=null)
            {
                Consecutivo = datos.Consecutivo;
            }
            if(datos.Movimiento!=null && datos.Movimiento[0].AreaQueRecibe==this.AreaQueConsulta.Area.AreaId && datos.Movimiento[0].FechaRecepcion==null)
            {
                Consecutivo = '<label class=text-warning>' + datos.Consecutivo + '</label>';
            }
            if(datos.Movimiento!=null && datos.Movimiento[0].AreaQueRecibe==this.AreaQueConsulta.Area.AreaId && datos.Movimiento[0].FechaRecepcion==null && datos.Movimiento[0].AreaExternaId!=null)
            {
                Consecutivo = '<label class=text-warning>' + datos.Consecutivo + '</label>';
            }
            if(datos.Movimiento!=null && datos.Movimiento[0].AreaQueRecibe!=this.AreaQueConsulta.Area.AreaId)
            {
                Consecutivo = '<label class=text-danger>' + datos.Consecutivo + '</label>'
            }
            return Consecutivo
        }

    },
    mounted(){
        this.AreaQueConsulta = this.$store.state.Login_Usuario;
        //console.log(this.AreaQueConsulta);
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Movimientos/EnvioSalaLectura.vue